import { render, staticRenderFns } from "./InformeSubscribe.vue?vue&type=template&id=8cb250c0&scoped=true&"
import script from "./InformeSubscribe.vue?vue&type=script&lang=js&"
export * from "./InformeSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./InformeSubscribe.vue?vue&type=style&index=0&id=8cb250c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb250c0",
  null
  
)

export default component.exports